const RE_ISO = /^\d{4}-\d{2}-\d{2}$/;
export function isISODate(s) {
    if (typeof s !== 'string' || !RE_ISO.test(s))
        return false;
    const d = new Date(s + 'T00:00:00Z');
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}
export const d2n = (iso) => Date.parse(iso + 'T00:00:00Z') / 86_400_000;
export const n2d = (n) => new Date(Math.round(n) * 86_400_000).toISOString().slice(0, 10);
export const addDays = (iso, n) => n2d(d2n(iso) + n);
export const diffDays = (a, b) => Math.round(d2n(b) - d2n(a));
/** 0 = domingo ... 6 = sábado */
export const weekday = (iso) => new Date(iso + 'T00:00:00Z').getUTCDay();
export const monthKey = (iso) => iso.slice(0, 7);
export function monthEnd(ym) {
    const [y, m] = ym.split('-').map(Number);
    return n2d(Date.UTC(y, m, 0) / 86_400_000);
}
export function addMonths(ym, n) {
    let [y, m] = ym.split('-').map(Number);
    m += n;
    while (m > 12) {
        m -= 12;
        y++;
    }
    while (m < 1) {
        m += 12;
        y--;
    }
    return `${y}-${String(m).padStart(2, '0')}`;
}
export function monthsBetween(a, b) {
    const out = [];
    let k = monthKey(a);
    const e = monthKey(b);
    for (let g = 0; k <= e && g < 1200; g++) {
        out.push(k);
        k = addMonths(k, 1);
    }
    return out;
}
export function formatBR(iso) {
    if (!iso || !isISODate(iso.slice(0, 10)))
        return '';
    const [y, m, d] = iso.slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
}
export function parseBR(s) {
    const t = s.trim();
    if (isISODate(t))
        return t;
    const m = t.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
    if (!m)
        return null;
    const iso = `${m[3]}-${m[2].padStart(2, '0')}-${m[1].padStart(2, '0')}`;
    return isISODate(iso) ? iso : null;
}
/** Data de hoje no fuso informado (padrão: Brasília). */
export function todayIn(timeZone = 'America/Sao_Paulo', now = new Date()) {
    return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
//# sourceMappingURL=dates.js.map